export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS";
export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const SIGN_UP_ERROR = "SIGN_UP_ERROR";
export const SIGN_IN_ERROR = "SIGN_IN_ERROR";
